import { EventInfo, Fetched, ImgixCrop, ImgixImage, RequestError } from "../types";
import fetch from "./fetch";
const organizationId = window.ORGANIZATION_ID;

type GenericEventError = { type: "ERROR_FETCHING_EVENT" };
type EventNotFoundError = {
  type: "EVENT_NOT_FOUND";
  eventId: number;
};

export type RequestEventError = EventNotFoundError | GenericEventError;

export const fetchEvent = async (
  eventId: string,
): Promise<Fetched<EventInfo> | RequestError<RequestEventError>> => {
  const response = await fetch(
    `/api/public/v3.0/organizations/${organizationId}/events/${eventId}`,
  );

  if (response.type === "client_error") {
    if (response.response.errors[0] === "event not found") {
      return {
        status: "error",
        error: {
          type: "EVENT_NOT_FOUND",
          eventId: response.response._error_type.event_id,
        },
      };
    }
  }

  if (response.type !== "success") {
    return {
      status: "error",
      error: {
        type: "ERROR_FETCHING_EVENT",
      },
    };
  }

  const json = response.response;

  const dataBag = json.event.data;

  const imgixImage = dataBag.image
    ? ({
        url: dataBag.image,
        crop: {
          height: dataBag.image_crop.height,
          width: dataBag.image_crop.width,
          offsetX: dataBag.image_crop.x,
          offsetY: dataBag.image_crop.y,
        } as ImgixCrop,
      } as ImgixImage)
    : null;

  const location = json.event.data.location;

  return {
    status: "fetched",
    entity: {
      description: json.event.description,
      directions: "",
      end: new Date(json.event.end),
      eventId: json.event.event_id,
      images: json.event.images,
      isLivestream: json.event.is_corona_livestream,
      image: imgixImage,
      information: json.information.map((info: any) => ({
        header: info.header,
        info: info.information,
        informationType: info.information_type,
      })),
      dateFormat: json.date_format
        ? {
            dateText: json.date_format.date_text,
            dateType: json.date_format.date_type,
          }
        : {
            dateText: "",
            dateType: "start_date_and_time",
          },
      ingress: "",
      invoiceAllowed: json.event.invoice_allowed,
      location: location.name,
      saleState: json.event.sale_state,
      mapData: location.coordinates
        ? {
            latitude: location.coordinates.latitude,
            longitude: location.coordinates.longitude,
            mapImage: true,
          }
        : {
            latitude: null,
            longitude: null,
            mapImage: false,
          },
      address:
        location &&
        (location.street_address !== "" ||
          location.postal_area !== "" ||
          location.postal_code !== "")
          ? {
              streetAddress: location.street_address,
              postalCode: location.postal_code,
              postalArea: location.postal_area,
            }
          : null,
      isCancelled: json.event.is_cancelled,
      name: json.event.name,
      start: new Date(json.event.start),
      maxPerTicket: json.event.data.max_tickets,
      subtitle: "",
      hasPromoCodes: json.event.has_promo_codes,
      category:
        json.event.data.category === "OTHER" && json.event.data.other_category_description
          ? json.event.data.other_category_description
          : json.event.data.category,
    },
  };
};
